module.exports = __webpack_public_path__ + "img/tooth-primary.4c0fce43.svg";